import { useState, useRef } from 'react';

const useRefState = (initialState, log) => {
    const [state, setState] = useState(initialState);
    if (log) console.log(log, state);
    const stateRef = useRef(initialState);
    return [
        state,
        newState => {
            stateRef.current = newState;
            setState(newState);
        },
        stateRef
    ];
};

export default useRefState;
